import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

export const dynamicBoxApi = createApi({
  reducerPath: "dynamicBoxApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `https://api.skio.com/storefront-http/`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getDynamicBox: builder.query({
      queryFn: async (productPlatformIds) => {
        try {
          const [response1, response2] = await Promise.all([
            axios.post(
              "https://api.skio.com/storefront-http/get-dynamic-box",
              {
                productPlatformId: productPlatformIds[0],
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            ),
            axios.post(
              "https://api.skio.com/storefront-http/get-dynamic-box",
              {
                productPlatformId: productPlatformIds[1],
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            ),
          ]);

          return { data: { data1: response1.data, data2: response2.data } };
        } catch (error) {
          return { error: { status: error.response?.status, data: error.message } };
        }
      },
    }),
  }),
});

export const { useGetDynamicBoxQuery } = dynamicBoxApi;
